var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.canCreateClients)?_c('RequestButton',{attrs:{"text":"Mandant erstellen","loading":_vm.client.createResponse.loading,"error":_vm.client.createResponse.error},on:{"click":function($event){return _vm.client.create()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }